<sym-card-dialog [title]="'Confirmation'" [closeMethod]="closeDialog">
    <span style="font-size: 16px;margin: 1em 0">You are about to approve {{captureCount}} readings for the {{month}} period</span>
    <div fxLayout="row" fxLayoutAlign="end center" style="margin-top: 2em;">
        <button mat-button style="color: #41535D;border-radius: 100px;border: 1px solid #E7E7E7;" (click)="closeDialog(false)">Cancel</button>
        <button (click)="closeDialog(true)" mat-button style="color: white;background-color: #41535D;border-radius: 100px;margin-left: .5em;">Confirm</button>
    </div>
</sym-card-dialog>